import { ModuleItem, ModuleList } from './types';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { environment } from '../../../../environments/environment';

export const TenantModules: ModuleItem[] = [
    {
        id: 'dashboard',
        name: _('AI RFX Automation'),
        href: '/dashboard',
        isFavorite: false,
        icon: 'bug',
    },
    {
        id: 'settings',
        name: 'SettingsModule.mainTitle',
        href: '/settings',
        isFavorite: false,
        icon: 'setting',
        direction: 'vertical',
        submodules: [
            // turning off profile settings for now
            // {
            //     title: _('settings.profile'),
            //     href: '/settings/profile',
            // },
            // {
            //     title: _('settings.systemsNotifications'),
            //     href: '/settings/systems-notifications',
            // },
            // {
            //     title: _('settings.groups'),
            //     href: '/settings/groups',
            // },
            {
                title: _('SettingsModule.resetPassword'),
                href: '/settings/reset-password',
            },
        ],
    },
    {
        id: 'aimarketing',
        name: _('Ai Marketing'),
        href: '/aimarketing/sales-history',
        isFavorite: false,
        icon: 'hdd',
        direction: 'vertical',
        submodules: [
            {
                title: _('AiMarketing.salesHistory'),
                href: '/aimarketing/sales-history',
            },
            // {
            //     title: _('AiMarketing.budgetForecast'),
            //     href: '/aimarketing/budget-forecast',
            // },
            {
                title: _('AiMarketing.budgetSummary'),
                href: '/aimarketing/budget-summary',
            },
            {
                title: _('AiMarketing.expanditureAnalysis'),
                href: '/aimarketing/expanditure-analysis',
            },
            {
                title: _('AiMarketing.modelOptimization.menuTitle'),
                href: '/aimarketing/model-optimization',
            },
            // {
            //     title: _('AiMarketing.mediaAttribute'),
            //     href: '/aimarketing/media-attribute',
            // },
            // {
            //     title: _('AiMarketing.summaryManagement'),
            //     href: '/aimarketing/management-summary',
            // },
            // {
            //     title: _('AiMarketing.productSummary'),
            //     href: '/aimarketing/product-summary',
            // },
        ],
    },
    {
        id: 'rfx',
        name: _('AI RFX Automation'),
        href: '/rfx',
        isFavorite: false,
        icon: 'bug',
        direction: 'horizontal',
        submodules: [
            {
                title: 'RFX List',
                href: '/rfx',
                params: {
                    sortDirection: 'DESC',
                    sortBy: 'createdAt',
                },
            },
        ],
    },
    {
        id: 'demandforecasting',
        name: _('AI Demand  Forecasting'),
        href: '/demandforecasting/planning',
        isFavorite: true,
        icon: 'fund',
        direction: 'horizontal',
        submodules: [
            {
                title: _('DemandForecasting.planningMenu'),
                href: '/demandforecasting/planning',
            },
            // {
            //     title: _('DemandForecasting.KPIMenu'),
            //     href: '/demandforecasting/kpi',
            // },
            {
                title: _('DemandForecasting.productMenu'),
                href: '/demandforecasting/products',
            },
            {
                title: _('DemandForecasting.clientsMenu'),
                href: '/demandforecasting/clients',
            },
            {
                title: _('DemandForecasting.forecastMenu'),
                href: '/demandforecasting/forecast',
            },
            {
                title: _('DemandForecasting.dataMenu'),
                href: '/demandforecasting/data-upload',
            },
        ],
    },
    {
        id: 'market-reports',
        name: _('MarketReports.title'),
        href: '/market-reports',
        isFavorite: false,
        icon: 'bar-chart',
        direction: 'horizontal',
        submodules: [
            {
                title: _('MarketReports.submodules.dashboard'),
                // Its href is a prefix of the admin one, so without this it stays lit on it.
                exactActive: true,
                href: '/market-reports',
            },
            {
                title: _('MarketReports.submodules.admin'),
                href: '/market-reports/admin',
            },
        ],
    },
    {
        id: 'warehouse-shelving',
        name: _('WarehouseShelving.title'),
        href: '/warehouse-shelving/dashboard',
        isFavorite: false,
        icon: 'appstore',
        direction: 'horizontal',
        submodules: [
            {
                title: _('WarehouseShelving.submodules.dashboard'),
                href: '/warehouse-shelving/dashboard',
            },
        ],
    },
    {
        id: 'aicontract',
        name: _('AI Contract Intelligence'),
        href: '/aicontract',
        isFavorite: false,
        icon: 'bug',
        direction: 'horizontal',
        submodules: [
            {
                title: _('AiContract.search'),
                href: '/aicontract/search',
            },
            {
                title: _('AiContract.dashboard'),
                href: '/aicontract/dashboard',
            },
            {
                title: _('AiContract.contractAi'),
                href: '/aicontract/ai-contract',
            },
        ],
    },
    {
        id: 'offercompiler',
        name: _('AI Offer Compiler'),
        href: '/offercompiler',
        isFavorite: false,
        icon: 'project',
        direction: 'horizontal',
    },
    {
        id: 'ai-tv-media-buyer',
        name: _('AiTvMediaBuyer.module.title'),
        href: '/ai-tv-media-buyer',
        isFavorite: false,
        icon: 'project',
        direction: 'horizontal',
        submodules: [
            ...(environment.name === 'dev' || environment.name === 'local'
                ? [{ title: 'Swagger', href: '/ai-tv-media-buyer/swagger' }]
                : []),
            {
                title: _('AiTvMediaBuyer.module.submodules.dashboard'),
                href: '/ai-tv-media-buyer/dashboard',
            },
            {
                title: _('AiTvMediaBuyer.module.submodules.correspondence'),
                href: '/ai-tv-media-buyer/correspondence',
            },
            {
                title: _('AiTvMediaBuyer.module.submodules.reservations'),
                href: '/ai-tv-media-buyer/reservation',
            },
            {
                title: _('AiTvMediaBuyer.module.submodules.settings'),
                href: '/ai-tv-media-buyer/settings',
            },
        ],
    },
];
export const ExternalModuleList: Partial<ModuleList[]> = [
    {
        blockTitle: _('DashboardModule.externalModules'),
        modules: [
            {
                id: 'ontology',
                name: _('AI Ontology'),
                href: environment.ontology,
                isLinkExternal: true,
                icon: 'export',
            },
        ],
    },
];

export const BaseModuleList: ModuleList[] = [
    {
        blockTitle: _('General'),
        modules: [
            {
                name: _('Main Board'),
                href: '/dashboard',
                icon: 'desktop',
            },
            {
                name: 'notifications.notifications',
                href: '/notifications',
                icon: 'bell',
            },
        ],
    },
    {
        blockTitle: _('Modules'),
        modules: [...TenantModules],
    },
    // {
    //     blockTitle: 'Ulubione',
    //     modules: [...AllModules.filter(module => module.isFavorite)],
    // },
];

export const LanguageSwitcherModuleItem: ModuleItem = {
    name: 'LanguageSwitcher',
    icon: 'flag',
};
